<template>
  <main v-if="loggedIn === false">
    <PageIntro
      v-if="appLogin === false"
      :heading="
        'Sign in with your <span>' +
        configStrings.clubName +
        ' ' +
        configStrings.productName +
        '</span> '
      "
      :body="
        '<p>Sign in below to your ' +
        configStrings.clubName +
        ' ' +
        configStrings.productName +
        ' for seamless access to exclusive content.</p><p>If you haven’t created an account yet click to register below. One time registration required with your email.</p>'
      "
    />

    <Login />

    <FooterShout v-if="appLogin === false" :type="'register'" />
  </main>
</template>

<script>
import Login from "@/components/Login";
import PageIntro from "@/components/PageIntro";
import FooterShout from "@/components/FooterShout";

export default {
  components: {
    Login,
    PageIntro,
    FooterShout,
  },
  data() {
    return {
      from: null,
      appLogin: false,
      loggedIn: true, //assume they are logged in
    };
  },
  mounted() {
    // if they are coming from the app specific login URL adapt the page accordingly

    if (this.$router.currentRoute.name === "app-login") {
      this.appLogin = true;
    }
    if (this.$getAuthenticatedUser() != null) {
      this.loggedIn = true;
    } else {
      this.loggedIn = false;
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.from = from;

      // TODO: Make sure we handle people referred from password reset with a message on sign in page
    });
  },
};
</script>